import { RootState } from "./store";

const selectAppState = (state: RootState) => state.app;

export const selectToken = (state: RootState) => selectAppState(state).token;

export const selectIsLoggedIn = (state: RootState) => selectAppState(state).isLoggedIn;

export const selectActiveFirm = (state: RootState) => selectAppState(state).activeFirm;

export const selectBreadcrumbs = (state: RootState) => selectAppState(state).breadcrumbs;

export const selectSelectedFolderGuid = (state: RootState) => selectAppState(state).selectedFolderGuid;
